import { required } from 'AppReact/schema';
import Schema from 'AppReact/schema';

const tag = {
  name: required('string'),
  color: required('string')
}

export default {
  tag: Schema(tag, 'object', { defaultValue: { text: '', color: '' } }),
  value: Schema('string', 'primitive', { defaultValue: '' }),
  color: Schema('string', 'primitive', { defaultValue: '' }),
  maxLength: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  isEditingName: Schema('boolean', 'primitive-nullable', { defaultValue: false }),
  isEditingColor: Schema('boolean', 'primitive-nullable', { defaultValue: false }),
  inputRef: Schema({}, 'object', { defaultValue: null }),
  tagInputRef: Schema({}, 'object', { defaultValue: null }),
  containerRef: Schema({}, 'object', { defaultValue: null }),
}
